import { Router, NavigationEnd } from "@angular/router";
import { DynamicDialogRef } from "primeng/dynamicdialog";

export abstract class ModalServiceBase {
    dialogRefs: DynamicDialogRef[] = [];
    constructor(
      private router: Router
    ) {
  
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          for (const ref of this.dialogRefs) {
            ref.close()
          }
          this.dialogRefs = [];
        }
      })
  
    }

    protected requireDialogRef<T>(ref: DynamicDialogRef<T> | null): DynamicDialogRef<T> {
      if (!ref) {
        throw new Error('Dialog failed to open');
      }
      return ref;
    }
  
   protected registerDialog(ref: DynamicDialogRef | null) {
      if (!ref) {
        return;
      }
      if (!this.dialogRefs.includes(ref)) {
        this.dialogRefs.push(ref);
        ref.onClose.subscribe(() => {
          this.dialogRefs.splice(this.dialogRefs.findIndex(existingRef => existingRef === ref), 1)
        })
      }
    }
}